import React, { useState, useEffect } from 'react';
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import { Select, Table } from 'antd';
import { DatePicker } from 'antd'
import { _doGetWasteManagementData, _doGetWasteManagementList } from './Wastemangementservice';
import * as XLSX from 'xlsx';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
const { Option } = Select;
const { RangePicker } = DatePicker;

const WasteManagementDashboard = () => {
    const dispatch = useDispatch()
    const citylist = useSelector(state => state?.WasteManagement?.WasteManagementData?.CityList)
    const storeslist = useSelector(state => state?.WasteManagement?.WasteManagementData?.StoresList)
    const tableData = useSelector(state => state?.WasteManagement?.WasteManagementList?.WasteManagementTable)
    const RecycleValues = useSelector(state => state?.WasteManagement?.WasteManagementList?.WasteManagementValues)

    const TableColumns = [
        {
            title: "Date",
            dataIndex: "created_date",
            key: "Date"
        },
        {
            title: "Pick Up",
            dataIndex: "pick_up_status",
            key: "Pick Up",
        },
        {
            title: "City",
            dataIndex: "code_value",
            key: "City",
        },
        {
            title: "Store Name",
            dataIndex: "store_name",
            key: "StoreName",
        },
        {
            title: "Daily Manager",
            dataIndex: "daily_manager",
            key: "DailyManager",
        },
        {
            title: "Category",
            dataIndex: "category_name",
            key: "Category",
        },
        {
            title: "Weight (in kg)",
            dataIndex: "category_weight",
            key: "Weight",
        }
    ];
    const [storeData, setstoreData] = useState([])
    const [WastemanagmentData, setWastemangementdata] = useState(
        {
            fromdate:'',
            todate:'',
            storeid:[],
        }
    )

    useEffect(() => {
        dispatch(_doGetWasteManagementData())
    }, [])

    const exportToExcel = (recycleValues=[], tableData=[]) => {
        const wb = XLSX.utils.book_new();
      
        // Exporting Waste Management Values sheet
        const wsData1 = [
          ['Total Waste Measured (in kg)', 'Recycled (in kg)', 'Incinerated/Sent to landfill (in kg)', 'Recycle Rate (%)'],
          [recycleValues[0]?.waste_management_total_wastage, recycleValues[0]?.waste_management_total_recycled, recycleValues[0]?.waste_management_total_not_recycled, recycleValues[0]?.waste_management_total_percentage]
        ];
        const ws1 = XLSX.utils.aoa_to_sheet(wsData1);
        XLSX.utils.book_append_sheet(wb, ws1, 'Waste Management Values');
      
        // Exporting Waste Management List sheet
        const wsData2 = [
          ['Date', 'Pick Up', 'City', 'Store Name', 'Cost Center', 'Daily Manager', 'Category', 'Weight (in Kg)'],
          ...tableData.map(item => [item.created_date, item.pick_up_status, item.code_value, item.store_name, item.store_costcenter, item.daily_manager, item.category_name, item.category_weight])
        ];
        const ws2 = XLSX.utils.aoa_to_sheet(wsData2);
        XLSX.utils.book_append_sheet(wb, ws2, 'Waste Management List');
      
        XLSX.writeFile(wb, 'WasteManagementReport.xlsx');
      };

    const _filterstoredata = (value) => {
        console.log(value, 'storeid')
        setstoreData([]);
        setWastemangementdata({...WastemanagmentData, storeid:[]})
        var StoreData = [];
        for(let i = 0 ; i < value.length; i++ ){
            let fetchedData = storeslist?.filter(ele => ele.store_city == value[i]).map(data => StoreData.push(data))
        }
        setstoreData(StoreData);
    }

    const _displayTableData = () => {
       dispatch(_doGetWasteManagementList(WastemanagmentData))
    }
    function disabledDate(current) {

        let date = dayjs(WastemanagmentData.fromdate, 'DD-MM-YYYY').subtract(1, 'day');
        return current && current < date.endOf('day');
      }
    
    return (
        <>
            <div className='wrapper'>
                <Header title='Waste Management Dashboard' />
                <Menu />
                <div className='content-wrapper'>
                    <section className="content">
                        <div className="m-panel mt-10">
                            <div className="m-panel__body p10 pb-10">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="exampleInput">
                                                From Date
                                            </label>
                                            <DatePicker 
                                            onChange={(date, dateString) => setWastemangementdata({...WastemanagmentData, fromdate:dateString})}
                                            size={12} format={'DD-MM-YYYY'} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="exampleInput">
                                                To Date
                                            </label>
                                            <DatePicker 
                                            disabledDate={disabledDate}
                                            onChange={(date, dateString) => setWastemangementdata({...WastemanagmentData, todate:dateString})}
                                            size={12} format={'DD-MM-YYYY'} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group select_h150">
                                            <label htmlFor="exampleInput">
                                                City
                                            </label>
                                            <Select
                                                className="form-control"
                                                showSearch
                                                onChange={(value) => (setWastemangementdata({...WastemanagmentData, storecity:value}), _filterstoredata(value))}
                                                mode="multiple"
                                                placeholder="--Select All--"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {
                                                    citylist?.map(((item, index) =>
                                                        <Option key={index} value={item.store_city}>{item.code_value}</Option>
                                                    ))
                                                }

                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group select_h150">
                                            <label htmlFor="exampleInput">
                                                Store Name
                                            </label>
                                            <Select
                                                className="form-control"
                                                onChange={(value) => setWastemangementdata({...WastemanagmentData, storeid:value})}
                                                showSearch
                                                mode="multiple"
                                                placeholder="--Select All--"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                value={WastemanagmentData.storeid}
                                            >
                                                {
                                                    storeData?.map(((item, index) =>
                                                        <Option key={index} value={item.store_id}>{item.store_name}</Option>
                                                    ))
                                                }
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <button onClick={() => _displayTableData()} className='btn btn-secondary deca-btn-yellow'>
                                            Generate
                                        </button>
                                    </div>
                                    <div className="col-md-3">
                                        <button
                                        className='btn btn-secondary deca-btn-yellow'
                                        onClick={() => exportToExcel(RecycleValues, tableData)}
                                        >
                                        Export to Excel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="m-panel">
                            <div className="m-panel__body p10 pb-10">
                                <h4 className='computation_head'>Computation</h4>
                                <div className='m-panel__body_computation'>
                                    <div className='row'>
                                        <div className='col-md-3 text-center'>
                                            <div className='computation_item'>
                                                <div className='computation_item-header'>
                                                    <h5>Total Waste Measured (in kg)</h5>
                                                </div>
                                                <div className='computation_item-content'>
                                                    <h5>{RecycleValues && RecycleValues[0]?.waste_management_total_wastage}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-3 text-center'>
                                            <div className='computation_item'>
                                                <div className='computation_item-header'>
                                                    <h5>Recycled (in kg)</h5>
                                                </div>
                                                <div className='computation_item-content'>
                                                    <h5>{RecycleValues && RecycleValues[0]?.waste_management_total_recycled}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-3 text-center'>
                                            <div className='computation_item'>
                                                <div className='computation_item-header'>
                                                    <h5>Incinerated/Sent to landfill (in kg)</h5>
                                                </div>
                                                <div className='computation_item-content'>
                                                    <h5>{RecycleValues && RecycleValues[0]?.waste_management_total_not_recycled}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-3 text-center'>
                                            <div className='computation_item'>
                                                <div className='computation_item-header'>
                                                    <h5>Recycle Rate (%)</h5>
                                                </div>
                                                <div className='computation_item-content'>
                                                    <h5>{RecycleValues && RecycleValues[0]?.waste_management_total_percentage}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="m-table__main">
                                            <div className="m-table__responsive medium-width">
                                                <Table
                                                    pagination={false}
                                                    scroll={{ y: 300 }}
                                                    columns={TableColumns}
                                                    dataSource={tableData}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div >
        </>
    );
}


export default WasteManagementDashboard;
